/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Choosefromlibrary2Inputs */

const en_choosefromlibrary2 = /** @type {(inputs: Choosefromlibrary2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose from library`)
};

const de_choosefromlibrary2 = /** @type {(inputs: Choosefromlibrary2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus Mediathek wählen`)
};

/**
* | output |
* | --- |
* | "Choose from library" |
*
* @param {Choosefromlibrary2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const choosefromlibrary2 = /** @type {((inputs?: Choosefromlibrary2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Choosefromlibrary2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_choosefromlibrary2(inputs)
	return de_choosefromlibrary2(inputs)
});
export { choosefromlibrary2 as "chooseFromLibrary" }